import {
  createStore,
  applyMiddleware
} from 'redux'

/*
import {
  composeWithDevTools
} from 'remote-redux-devtools'
 */

import {
  composeWithDevTools
} from 'redux-devtools-extension/developmentOnly'

import middleware from './middleware'

import reducer from './reducer'

const composeEnhancers = composeWithDevTools({
  realtime: true
})

export default function configureStore () {
  const store = createStore(reducer, composeEnhancers(
    applyMiddleware(...middleware)
  ))

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      store.replaceReducer(reducer)
    })

    module.hot.decline('./middleware')
  }

  return store
}
